import { isNumber, zl } from "../../../functions/utilities";

const WodaOdczytyRazemSzczegolyWm = props => {

    const { wybraneRozliczenie } = props;

    const zimna_poczatek = isNumber(wybraneRozliczenie?.zimnaWmPoczatek) ? ( `${wybraneRozliczenie?.zimnaWmPoczatek} m³` ) : "brak";
    const zimna_koniec = isNumber(wybraneRozliczenie?.zimnaWmKoniec) ? ( `${wybraneRozliczenie?.zimnaWmKoniec} m³` ) : "brak";

    const zimna_razem = isNumber(wybraneRozliczenie?.zuzycieWmZimna) ? wybraneRozliczenie?.zuzycieWmZimna : '-';

    return (
        <div className="blok">
            <div className="woda-wiersz">
                <p className="opis">
                    Zużycie łączne WM:
                </p>
                <p className="zuzycie">
                    {`(${zimna_poczatek} / ${zimna_koniec}) ${zimna_razem} m³`}
                </p>
            </div>
            <div className="woda-wiersz">
                <p className="opis">
                    Straty wody zimnej:
                </p>
                <p className="zuzycie">
                    {`${wybraneRozliczenie?.strata || 0} m³`}
                </p>
            </div>
            <div className="woda-wiersz">
                <p className="opis">
                    Koszt podgrzania wody (wg faktur PEC):
                </p>
                <p className="zuzycie">
                    {`${zl(wybraneRozliczenie?.kosztPodgrzaniaCieplej)}`}
                </p>
            </div>
        </div>
    )
}

export default WodaOdczytyRazemSzczegolyWm;